/**
 * Modal Service
 * Manages modal state and prevents duplicate modals
 */

import { Injectable, signal } from '@angular/core';

export interface ModalState {
  id: string;
  isOpen: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private _activeModals = signal<Map<string, boolean>>(new Map());

  /**
   * Open a modal by ID
   */
  openModal(modalId: string): void {
    const modals = this._activeModals();
    modals.set(modalId, true);
    this._activeModals.set(new Map(modals));
  }

  /**
   * Close a modal by ID
   */
  closeModal(modalId: string): void {
    const modals = this._activeModals();
    modals.delete(modalId);
    this._activeModals.set(new Map(modals));
  }

  /**
   * Check if a modal is open
   */
  isModalOpen(modalId: string): boolean {
    return this._activeModals().get(modalId) || false;
  }

  /**
   * Close all modals
   */
  closeAllModals(): void {
    this._activeModals.set(new Map());
  }

  /**
   * Get count of open modals
   */
  getOpenModalCount(): number {
    return this._activeModals().size;
  }
}
